// Mock data for Turtlemint clone
export const stats = [
  { value: '2000+', label: 'Policies Sold' },
  { value: '100+', label: 'Claims Supported' },
  { value: '42', label: 'Insurers' },
];

export const partners = [
  'HDFC ERGO', 'ICICI Lombard', 'Bajaj Allianz', 'TATA AIG', 'Star Health',
  'Max Life', 'SBI Life', 'LIC', 'Reliance General', 'Niva Bupa',
  'Kotak Life', 'Aditya Birla', 'Royal Sundaram', 'Future Generali', 'Care Health',
  'New India', 'Oriental', 'National Insurance', 'PNB MetLife', 'Exide Life'
];

export const products = [
  { name: 'Health', subtitle: 'Insurance', icon: 'Heart', color: 'from-emerald-50 to-emerald-100', iconColor: 'text-emerald-600' },
  { name: 'Car', subtitle: 'Insurance', icon: 'Car', color: 'from-blue-50 to-blue-100', iconColor: 'text-blue-600' },
  { name: 'Bike', subtitle: 'Insurance', icon: 'Bike', color: 'from-orange-50 to-orange-100', iconColor: 'text-orange-600' },
  { name: 'Life', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-purple-50 to-purple-100', iconColor: 'text-purple-600' },
  { name: 'Term', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-teal-50 to-teal-100', iconColor: 'text-teal-600' },
  { name: 'Group Term', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-cyan-50 to-cyan-100', iconColor: 'text-cyan-600' },
  { name: 'Group Health', subtitle: 'Insurance', icon: 'Heart', color: 'from-emerald-50 to-lime-100', iconColor: 'text-lime-600' },
  { name: 'Personal Accident', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-amber-50 to-amber-100', iconColor: 'text-amber-600' },
  { name: 'Home', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-stone-50 to-stone-100', iconColor: 'text-stone-600' },
  { name: 'Workmen Compensation', subtitle: 'Insurance', icon: 'Briefcase', color: 'from-indigo-50 to-indigo-100', iconColor: 'text-indigo-600' },
  { name: 'Fire & Burglary', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-red-50 to-red-100', iconColor: 'text-red-600' },
  { name: 'Marine', subtitle: 'Insurance', icon: 'ShieldCheck', color: 'from-sky-50 to-sky-100', iconColor: 'text-sky-600' },
  { name: 'HDFC Life', subtitle: 'Business Associate', icon: 'ShieldCheck', color: 'from-violet-50 to-violet-100', iconColor: 'text-violet-600' },
  { name: 'Care Health', subtitle: 'Business Associate', icon: 'Heart', color: 'from-pink-50 to-pink-100', iconColor: 'text-pink-600' },
];

export const advisorFeatures = [
  { title: 'Sell insurance, mutual funds, loans & more', desc: 'Get instant access to a wide range of insurance, investment, credit, and loan products.', icon: 'Package' },
  { title: 'Marketing tools to grow your business', desc: 'Effortless customer management with personalised shareable content for lead generation.', icon: 'Megaphone' },
  { title: 'Get support from quotes to claims', desc: 'A dedicated relationship manager and an expert support team', icon: 'Headphones' },
  { title: 'Training on latest products & sales skills', desc: 'POSP training made easy with 500+ videos, live webinars, and classroom sessions.', icon: 'GraduationCap' },
];

export const consumerFeatures = [
  { title: 'Policies at your fingertips', desc: 'Track policy benefits, get offline share them with your family', icon: 'FileText' },
  { title: 'We handle your claims', desc: 'Experts to guide and handle your claims to get you the best payouts', icon: 'ShieldCheck' },
  { title: 'Renewal reminders & exclusive offers', desc: 'Never miss a deadline with personalised alerts and hassle-free renewal options', icon: 'BellRing' },
];

export const turtlefinSolutions = [
  { title: 'Banks & NBFCs', desc: 'Offer customers a convenient, one-stop digital insurance experience across all channels.', icon: 'Landmark' },
  { title: 'Insurers', desc: 'APIs platform for quick digital launch of your products. Go to market in less than 30 days.', icon: 'Building2' },
  { title: 'E-commerce', desc: 'Attach and sell insurance in your online journeys; turbo-charge your insurance business.', icon: 'ShoppingCart' },
  { title: '& your business…', desc: 'Use case in mind? We can offer you a bespoke solution.', icon: 'Sparkles' },
];

export const ctaCards = [
  { title: 'Get an Insurance Quote', desc: 'Find the perfect insurance coverage tailored to your needs', cta: 'Explore Now', variant: 'primary', icon: 'FileSearch' },
  { title: 'Book a Free Consultation', desc: 'Speak with our expert advisors on the best plan for you', cta: 'Book Now', variant: 'secondary', icon: 'UserPlus' },
  { title: 'Claim Support & Renewals', desc: 'Hassle-free claim settlement and policy renewals — end to end', cta: 'Learn More', variant: 'tertiary', icon: 'Blocks' },
];

export const footerLinks = {
  Company: ['About Us', 'Careers', 'Contact Us', 'Press', 'Blog'],
  Products: ['Health Insurance', 'Car Insurance', 'Bike Insurance', 'Life Insurance', 'Term Insurance', 'Travel Insurance'],
  Resources: ['Insurance Guides', 'Claim Process', 'Tools & Calculators', 'FAQs', 'Support Center'],
  };

export const expertCategories = [
  { name: 'Health', icon: 'Heart' },
  { name: 'Life', icon: 'ShieldCheck' },
  { name: 'Motor', icon: 'Car' },
];

export const expertReasons = [
  { name: 'Purchase a New Policy', icon: 'ShoppingBag' },
  { name: 'Renew Policy', icon: 'RefreshCw' },
  { name: 'Review Insurance Portfolio', icon: 'PieChart' },
];
